export default __webpack_public_path__ + "static/media/bg-banner.e436e493.webp";